// Per-template color palettes, ported 1:1 from the Figma Voyager Pro source
// (src/data/types.ts QUOTE_TEMPLATES[].vars) - these are CSS custom property
// *overrides* applied on top of the app-wide Voyager Pro tokens defined in
// styles/voyagerTheme.css (--background/--foreground/--primary/--accent/
// --muted/--muted-foreground/--border). 'modern' has no override in Figma
// (empty vars: {}) because it IS the base Voyager Pro theme already used
// throughout the rest of the reskinned app.
//
// Usage: spread the palette object into a root element's `style` prop, then
// reference the vars via Tailwind arbitrary values (e.g. bg-[var(--background)],
// text-[var(--foreground)], bg-[var(--primary)], text-[var(--accent)],
// bg-[var(--muted)], text-[var(--muted-foreground)], border-[var(--border)]).
export const TEMPLATE_PALETTES = {
  modern: {},
  magical: {
    '--background': '#13082a',
    '--foreground': '#f0e8ff',
    '--primary': '#5b21b6',
    '--accent': '#fbbf24',
    '--muted': '#1e0f42',
    '--muted-foreground': '#c4b5fd',
    '--border': '#3b1a7a',
  },
  modern_agency: {
    '--background': '#0f172a',
    '--foreground': '#f1f5f9',
    '--primary': '#334155',
    '--accent': '#38bdf8',
    '--muted': '#1e293b',
    '--muted-foreground': '#94a3b8',
    '--border': '#334155',
  },
  editorial_magazine: {
    '--background': '#faf7f2',
    '--foreground': '#1c1917',
    '--primary': '#292524',
    '--accent': '#92400e',
    '--muted': '#f5f0e8',
    '--muted-foreground': '#78716c',
    '--border': '#e7e0d6',
  },
  expedition_adventure: {
    '--background': '#f0f4f0',
    '--foreground': '#1a2b1c',
    '--primary': '#14532d',
    '--accent': '#ca8a04',
    '--muted': '#e4ede6',
    '--muted-foreground': '#4a7c59',
    '--border': '#c0d5c4',
  },
  executive_brief: {
    '--background': '#ffffff',
    '--foreground': '#0f172a',
    '--primary': '#1e293b',
    '--accent': '#475569',
    '--muted': '#f8fafc',
    '--muted-foreground': '#64748b',
    '--border': '#e2e8f0',
  },
  studio_action: {
    '--background': '#090909',
    '--foreground': '#fafafa',
    '--primary': '#1c1c1c',
    '--accent': '#facc15',
    '--muted': '#161616',
    '--muted-foreground': '#a3a3a3',
    '--border': '#262626',
  },
  luxury_river: {
    '--background': '#f0f3f8',
    '--foreground': '#1a2744',
    '--primary': '#1e3a5f',
    '--accent': '#b8916a',
    '--muted': '#e4eaf4',
    '--muted-foreground': '#5a7199',
    '--border': '#c8d5e8',
  },
  tropical_escape: {
    '--background': '#f0fdf7',
    '--foreground': '#0c3a31',
    '--primary': '#0d9488',
    '--accent': '#f97316',
    '--muted': '#dcfce7',
    '--muted-foreground': '#3d7a6a',
    '--border': '#a7d9d0',
  },
  boarding_pass: {
    '--background': '#f8fafc',
    '--foreground': '#1e293b',
    '--primary': '#312e81',
    '--accent': '#6366f1',
    '--muted': '#f1f5f9',
    '--muted-foreground': '#64748b',
    '--border': '#cbd5e1',
  },
  destination_wedding: {
    '--background': '#fdf8f4',
    '--foreground': '#3b1f1a',
    '--primary': '#9d3b50',
    '--accent': '#c9a96e',
    '--muted': '#f9ede8',
    '--muted-foreground': '#9b7b6e',
    '--border': '#edd5c8',
  },
};

export default TEMPLATE_PALETTES;
